

























import Vue from 'vue';
import { VOverlay, VDialog } from 'vuetify/lib';

export default Vue.extend({
  props: ['value', 'title'],
  components: { VOverlay, VDialog },
  data: () => ({
    modal: false
  }),
  methods: {},
  watch: {
    value: {
      handler(n) {
        this.modal = n;
      },
      deep: true
    },
    modal: {
      handler(n) {
        this.$emit('input', n);
      }
    }
  }
});
